mutation LeadRemoveSource($input: LeadRemoveSourceInput!) {
    leadRemoveSource(input: $input) {
        lead {
            id
        }
    }
}
